import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  staging: false,
  appName: 'Elevate',
  apiBaseUrl: 'https://qa-apis.elevate-education.in',
  googleClientId: '185309741028-8ljbd1eqq4lgnur7kf917k4hb2vr35ms.apps.googleusercontent.com',
};
